import React from 'react';
import { Table, Typography } from 'antd';
import NoRecordFound from '../NoRecordFound';

interface Props {
    dataSource?: any;
    columns?: any;
    title?: string;
}

const Orders = (props: Props) => {
    const { title } = props;

    return (
        <div className="orders-table">
            <Typography.Title className="setting-tab-heading" level={4} >{title} </Typography.Title>
            <Table dataSource={props?.dataSource} columns={props?.columns} pagination={false} locale={{
                emptyText: <div className="no-record-parent">
                    <div className="ant-empty-description">
                        Nothing in cart.
                    </div>
                </div>
            }} />
        </div >
    )
}

export default Orders;